import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const BillingAccountsPage = () => {
  return (
    <>
      <Helmet>
        <title>Billing Accounts - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
